/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_LiveInputs */

const vi_vehicle_camera_live = /** @type {(inputs: Vehicle_Camera_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang live`)
};

/**

* @param {Vehicle_Camera_LiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_live = /** @type {((inputs?: Vehicle_Camera_LiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_LiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_live(inputs)
});